import axios from "axios";

export async function fetchCompanyVehicles(companyId) {
  const r = await axios.get(`/api/vehicle/all?type=vehicle&company_id=${companyId}`);
  return r?.data?.data?.data ?? [];
}

export async function createVehicle(payload) {
  const r = await axios.post(`/api/vehicle`, payload);
  return r?.data?.data;
}

export async function updateVehicle(id, payload) {
  await axios.patch(`/api/vehicle/${id}`, payload);
}
